module.exports = __webpack_public_path__ + "img/issue_1.e14a2829.png";